import { createV3Queries } from "@query/utils/createV3Queries";
import { backgroundCheckConfigurationsApi } from "@api";

/**
 * Background-check-configuration registry — mirrors
 * `BackgroundCheckConfigurationsApi` 1:1
 * (`/v3/compliance/background-check-configurations`; create and read only).
 *
 * This is the v3 twin of the v1 `/background-checks/settings` resource: the
 * title, instructions and chosen package that a `BackgroundCheck` requirement
 * definition points at through its `dataSourceId`. Creating one is the only way
 * to obtain that id, so a definition of that type cannot be created without it.
 *
 * There is deliberately no update operation — a configuration is fixed once
 * definitions point at it — and no list, so the id must be held from the
 * original create.
 */
export const queriesBackgroundCheckConfigurations = createV3Queries(
  "backgroundCheckConfigurationsApi",
  backgroundCheckConfigurationsApi
);
